import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type N1Transaction, porfolios_columns } from "./columns";
import {
  type FilterN1TransactionsSchema,
  FilterN1Transactions,
} from "./filter";

export const N1TransactionsTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<N1Transaction>({
    client: Clients.N1,
    table_name: Tables.N1_TRANSACTIONS,
    resourceLabel: "Transactions",
  });

  return (
    <>
      <Table<N1Transaction, FilterN1TransactionsSchema>
        label="Transactions"
        client={Clients.N1}
        table_name={Tables.N1_TRANSACTIONS}
        columns={porfolios_columns}
        filter={<FilterN1Transactions />}
        actions={[
          {
            label: "actions.new",
            route: `${Clients.N1}/${Tables.N1_TRANSACTIONS}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
